import { LayoutTextSegment, VerticalAlign } from '@damofire/data-watson';
import { CanvasRenderer } from '@damofire/uix-commons';

function textBaseline(verticalAlign: VerticalAlign): CanvasTextBaseline {
  return verticalAlign === 'baseline' ? 'alphabetic' : (verticalAlign as CanvasTextBaseline);
}

export class LayoutTextRenderer extends CanvasRenderer {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    private readonly layoutTextSegment: LayoutTextSegment,
  ) {
    super();
  }
  draw(): void {
    const { text, xOrigin, yOrigin, rotation, fontHeight, horizontalAlign, verticalAlign } = this.layoutTextSegment;

    const radiantRotation = rotation * (Math.PI / 180);

    this.ctx.save();
    this.ctx.font = `100 ${fontHeight}px Open Sans`;
    this.ctx.fillStyle = '#888';
    this.ctx.textAlign = horizontalAlign;
    this.ctx.textBaseline = textBaseline(verticalAlign);
    this.ctx.translate(xOrigin, yOrigin);

    this.ctx.rotate(radiantRotation);
    this.ctx.scale(1, -1);
    this.ctx.fillText(text, 0, 0);
    this.ctx.restore();
  }
}
